import useProcessos from "../../hooks/useProcessos";
import useUsuarios from "../../hooks/useUsuarios";
import useClientes from "../../hooks/useClientes";
import useAgenda from "../../hooks/useAgenda";
import { useNavigate } from "react-router-dom"
import { getNomeAdvogado } from "../../utils/getNomeAdvogado";

import {
  PieChart,
  Pie,
  Cell,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Legend
} from "recharts"

const Dashboard = () => {

  const navigate = useNavigate();

  const { processos } = useProcessos();
  const { usuarios } = useUsuarios();
  const { agenda } = useAgenda();
  const { clientes } = useClientes();

  const totalProcessos = processos.length
  const totalClientes = clientes.length

  // =========================
  // AGRUPAMENTOS
  // =========================

  const processosPorArea = Object.values(
    processos.reduce((acc, p) => {
      const area = p.areaDireito || "Não informado"
      if (!acc[area]) acc[area] = { name: area, value: 0 }
      acc[area].value++
      return acc
    }, {})
  )

  const processosPorFase = Object.values(
    processos.reduce((acc, p) => {
      const fase = p.faseAcao || "Não informado"
      if (!acc[fase]) acc[fase] = { name: fase, total: 0 }
      acc[fase].total++
      return acc
    }, {})
  )

  const mapaUsuarios = Object.fromEntries(
    usuarios.map(u => [String(u._id), u])
  );

  const processosPorAdvogado = Object.values(
  processos.reduce((acc, p) => {

    if (!p.advogadoId) return acc;

    const nome = getNomeAdvogado(p.advogadoId, mapaUsuarios);

    if (!acc[nome]) acc[nome] = { name: nome, total: 0 };

    acc[nome].total++;

    return acc;

  }, {})
);

  // =========================
  // AGENDA / PRAZOS
  // =========================

  const hoje = new Date()

  const prazosVencidos = agenda.filter(a =>
    a.dataManifestacao &&
    new Date(a.dataManifestacao) < hoje
  )

  const prazosHoje = agenda.filter(a =>
    a.dataManifestacao &&
    new Date(a.dataManifestacao).toDateString() === hoje.toDateString()
  )

  const limite7 = new Date()
  limite7.setDate(hoje.getDate() + 7)

  const proximos7 = agenda.filter(a =>
    a.dataManifestacao &&
    new Date(a.dataManifestacao) > hoje &&
    new Date(a.dataManifestacao) <= limite7
  )

  const audiencias = agenda.filter(a =>
    a.dataAudiencia
  )

  const irParaProcessos = (filtro) => {
    navigate(`/processos?filtro=${filtro}`)
  }

  const cores = [
    "var(--cor-primaria)",
    "var(--cor-secundaria)",
    "var(--cor-destaque)",
    "#38A169",
    "#E53E3E"
  ]

  return (
    <div className="container">

      <h1>DASHBOARD</h1>
      <hr />

      {/* =========================
          KPIs
      ========================= */}
      <div className="agenda-indicadores">

        <div className="indicador">
          <h3>Total de Clientes</h3>
          <span>{totalClientes}</span>
        </div>

        <div className="indicador">
          <h3>Total de Processos</h3>
          <span>{totalProcessos}</span>
        </div>

        <div
          className="indicador"
          onClick={() => irParaProcessos("prazos_vencidos")}
          style={{ cursor: "pointer" }}
        >
          <h3>🔴 Prazos vencidos</h3>
          <span>{prazosVencidos.length}</span>
        </div>

        <div
          className="indicador"
          onClick={() => irParaProcessos("prazos_hoje")}
          style={{ cursor: "pointer" }}
        >
          <h3>🟡 Prazos hoje</h3>
          <span>{prazosHoje.length}</span>
        </div>

        <div
          className="indicador"
          onClick={() => irParaProcessos("prazos_7")}
          style={{ cursor: "pointer" }}
        >
          <h3>🟢 Próximos 7 dias</h3>
          <span>{proximos7.length}</span>
        </div>

        <div
          className="indicador"
          onClick={() => irParaProcessos("audiencias")}
          style={{ cursor: "pointer" }}
        >
          <h3>📅 Audiências</h3>
          <span>{audiencias.length}</span>
        </div>

      </div>

      {/* =========================
          GRÁFICOS
      ========================= */}
      <div className="dashboard-grid">

        <div className="card">
          <h2>Processos por Advogado</h2>
          <ResponsiveContainer width="100%" height={250}>
            <BarChart data={processosPorAdvogado}>
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="total" fill="var(--cor-primaria)" />
            </BarChart>
          </ResponsiveContainer>
        </div>

        <div className="card">
          <h2>Processos por Fase</h2>
          <ResponsiveContainer width="100%" height={250}>
            <BarChart data={processosPorFase}>
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="total" fill="var(--cor-secundaria)" />
            </BarChart>
          </ResponsiveContainer>
        </div>

        <div className="card">
          <h2>Processos por Área</h2>
          <ResponsiveContainer width="100%" height={250}>
            <PieChart>
              <Pie
                data={processosPorArea}
                dataKey="value"
                nameKey="name"
                outerRadius={90}
              >
                {processosPorArea.map((_, i) => (
                  <Cell key={i} fill={cores[i % cores.length]} />
                ))}
              </Pie>
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
        </div>

      </div>

    </div>
  )
}

export default Dashboard